"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPollStep = void 0;
var live_poll_rules_1 = require("../constants/live-poll-rules");
var live_1 = require("../ui-selectors/video/live");
var lodash_1 = require("lodash");
var getPollStep = function (videoItem) {
    var dateStartLive = videoItem.dateStartLive;
    var isPending = (0, live_1.isPendingLiveStream)(videoItem);
    if (isPending) {
        return live_poll_rules_1.pendingLivePollRule.step;
    }
    var timeGap = dateStartLive - Date.now(); // TODO: rewrite VideoItem
    var pollRule = (0, lodash_1.find)(live_poll_rules_1.pollRules, function (rule) {
        return timeGap < 0 ? timeGap > rule.timeToStart : rule.timeToStart > timeGap;
    });
    return pollRule && pollRule.step;
};
exports.getPollStep = getPollStep;
//# sourceMappingURL=live-poll.js.map